export default __webpack_public_path__ + "static/media/Facemask of the Bloodhunter (nm).ba7f09ae.jpg";